/*******************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2023 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ******************************************************************************/

import { UseEnhanceDispatch } from "components/EnhancedSpeech/useEnhanceSpeech/Reducer";
import { useEffect, useState } from "react";
import { useBuildEnhancement } from "components/EnhancedSpeech/useEnhanceSpeech/useBuildEnhancement";
import { useCurrentUser } from "actions/CurrentUserActions";
import { fetchEnhanceSpeechTracks } from "components/EnhancedSpeech/Utilities";

export const useLoadExistingEnhanceSpeechTracks = (
  dispatch: UseEnhanceDispatch
): boolean => {
  const [isLoadingInitial, setIsLoadingInitial] = useState(false);
  const buildEnhancements = useBuildEnhancement(dispatch);
  const { currentUser } = useCurrentUser();

  useEffect(() => {
    if (!currentUser) {
      return;
    }

    setIsLoadingInitial(true); // prevent uploads during initial fetch of existing tracks

    fetchEnhanceSpeechTracks().then(async (tracks) => {
      setIsLoadingInitial(false);
      dispatch({
        type: "LOAD_ENHANCEMENTS",
        enhancements: tracks.map(buildEnhancements),
      });
    });
  }, [buildEnhancements, currentUser, dispatch]);
  return isLoadingInitial;
};
